/*
 * ECharts 等图表容器尺寸变化时调用实例 resize。
 * 注意：@vueuse/core@8 没有导出 debouncedWatch，原实现会在生产环境变成 undefined 调用报错（y is not a function）。
 */
export default {
    mounted(el, binding) {
        let timer = null;
        const scheduleResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                const chart = binding.value;
                if (chart && typeof chart.resize === "function") {
                    chart.resize();
                }
            }, 400);
        };
        const ro = new ResizeObserver(scheduleResize);
        ro.observe(el);
        el.__chartResizeCleanup = () => {
            ro.disconnect();
            clearTimeout(timer);
        };
        scheduleResize();
    },
    updated(el, binding) {
        const chart = binding.value;
        if (chart && typeof chart.resize === "function") {
            chart.resize();
        }
    },
    unmounted(el) {
        if (typeof el.__chartResizeCleanup === "function") {
            el.__chartResizeCleanup();
            delete el.__chartResizeCleanup;
        }
    },
};
